import "../Assets/Scss/Button.scss";
import { CircularProgress } from "@mui/material";

const Button_fill = ({ name, children, Click, style = {}, isLoading }) => {
  return (
    <div onClick={Click} className="Button" style={style}>
      {isLoading ? (
        <CircularProgress color="inherit" size={14} />
      ) : name ? (
        name
      ) : (
        children
      )}
    </div>
  );
};

export default Button_fill;
